module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container_wrap organization_container"
  }, [_c('el-tabs', {
    staticClass: "eltab",
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, _vm._l((_vm.firstSecretaryTitleList), function(item, index) {
    return _c('el-tab-pane', {
      key: index,
      attrs: {
        "label": item.name,
        "name": item.name
      }
    }, [(item.content) ? _c('div', {
      staticClass: "tabpane_container html-data",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    }) : _c('div', {
      staticClass: "secretary_title"
    }, _vm._l((_vm.secretaryTitleList), function(item, index) {
      return _c('div', {
        key: index,
        staticClass: "secretary_title_item",
        class: item.class,
        on: {
          "click": function($event) {
            return _vm.secretarySortSelect(item)
          }
        }
      }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")])
    }), 0), _vm._v(" "), (!item.content) ? _c('div', {
      staticClass: "secretary_list"
    }, _vm._l((_vm.MemberList), function(item, index) {
      return _c('div', {
        key: index,
        staticClass: "memberlistitem"
      }, [_c('member-list-item', {
        attrs: {
          "memberlistitem": item
        }
      })], 1)
    }), 0) : _vm._e()])
  }), 1)], 1), _vm._v(" "), _c('DeBounce', {
    attrs: {
      "fetch-fun": _vm.DeBounceFetchData,
      "pagefetchflag": _vm.pagefetchflag
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner_container"
  }, [_c('div', {
    staticClass: "banner_title"
  }, [_vm._v("关于我们")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": require("@/assets/images/listitem/pic-banner@2x.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73bf34e6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/cms/CmsCate.vue
// module id = 1283
// module chunks = 0